"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareListItems = void 0;
const types_1 = require("./types");
const defaultDateTransform = (eventDate) => eventDate;
const prepareListItems = (events, pageSize, options) => {
    const groups = (options === null || options === void 0 ? void 0 : options.groups) || [];
    const dateTransform = (options === null || options === void 0 ? void 0 : options.dateTransform) || defaultDateTransform;
    const listItems = [];
    const pageNumbersOfListItems = [];
    let currentSport;
    let currentTournament;
    let currentDate;
    const sportGroupIndex = groups.indexOf('sport');
    const tournamentGroupIndex = groups.indexOf('tournament');
    const dateGroupIndex = groups.indexOf('date');
    events.forEach((event, index) => {
        const pageNumber = Math.floor(index / pageSize);
        groups.forEach((groupKey) => {
            if (groupKey === 'sport') {
                if (event.tournament.sportId !== currentSport) {
                    listItems.push({
                        type: types_1.EventsListItemType.Sport,
                        sportId: event.tournament.sportId,
                    });
                    pageNumbersOfListItems.push(pageNumber);
                    currentSport = event.tournament.sportId;
                    if (dateGroupIndex !== -1 && dateGroupIndex > sportGroupIndex) {
                        currentDate = undefined;
                    }
                    if (tournamentGroupIndex !== -1 &&
                        tournamentGroupIndex > sportGroupIndex) {
                        currentTournament = undefined;
                    }
                }
            }
            if (groupKey === 'tournament') {
                if (event.tournament.id !== currentTournament) {
                    listItems.push({
                        type: types_1.EventsListItemType.Tournament,
                        tournament: event.tournament,
                    });
                    pageNumbersOfListItems.push(pageNumber);
                    currentTournament = event.tournament.id;
                    if (dateGroupIndex !== -1 && dateGroupIndex > tournamentGroupIndex) {
                        currentDate = undefined;
                    }
                    if (sportGroupIndex !== -1 &&
                        sportGroupIndex > tournamentGroupIndex) {
                        currentSport = undefined;
                    }
                }
            }
            if (groupKey === 'date') {
                const eventDate = dateTransform(event.eventDate);
                if (eventDate !== currentDate) {
                    listItems.push({
                        type: types_1.EventsListItemType.Date,
                        date: eventDate,
                    });
                    pageNumbersOfListItems.push(pageNumber);
                    currentDate = eventDate;
                    if (tournamentGroupIndex !== -1 &&
                        tournamentGroupIndex > dateGroupIndex) {
                        currentTournament = undefined;
                    }
                    if (sportGroupIndex !== -1 && sportGroupIndex > dateGroupIndex) {
                        currentSport = undefined;
                    }
                }
            }
        });
        listItems.push({
            type: types_1.EventsListItemType.Event,
            event,
        });
        pageNumbersOfListItems.push(pageNumber);
    });
    return { listItems, pageNumbersOfListItems };
};
exports.prepareListItems = prepareListItems;
//# sourceMappingURL=prepareListItems.js.map